"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _stitches = require("../../../stitches.config");

var _wizardsSlice = require("../../../store/wizardsSlice");

var _Checkbox = require("../../input/checkbox/Checkbox");

var _ImageOrLottie = _interopRequireDefault(require("../image-or-lottie/ImageOrLottie"));

var _sharedStyles = require("../sharedStyles");

var StyledQuestion = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '500px'
});
var ChoicesContainer = (0, _stitches.styled)('div', {
  width: '100%'
});
var Choice = (0, _stitches.styled)('div', {
  alignItems: 'center',
  backgroundColor: '$white',
  border: '1px solid $grey400',
  borderRadius: '5px',
  boxSizing: 'border-box',
  display: 'flex',
  height: '70px',
  marginBottom: '15px',
  marginTop: '15px',
  padding: '16px',
  width: '100%',
  '@tablet': {
    height: 'auto'
  },
  '&:hover': {
    cursor: 'pointer'
  },
  div: {
    overflowWrap: 'break-word',
    fontWeight: '$semiBold'
  },
  input: {
    marginLeft: '5px',
    marginRight: '25px',
    '@tablet': {
      marginLeft: '15px',
      marginRight: '50px'
    },
    // unset sfcc styles
    fontSize: 'unset',
    left: 'unset',
    opacity: 'unset',
    padding: 'unset',
    position: 'relative',
    textIndent: 'unset',
    width: 'unset'
  },
  variants: {
    selected: {
      true: {
        border: '2px solid $secondary',
        padding: '15px'
      }
    }
  }
}); // This is used so that we don't collpase the empty space when we select a new answer.

var LottieWrapper = (0, _stitches.styled)('div', {
  height: '130px',
  div: {
    margin: 'auto',
    marginTop: '20x',
    width: '50%',
    '@tablet': {}
  },
  '@tablet': {
    height: '130px'
  },
  '@desktop': {
    height: '150px'
  }
});
/**
 * A question with rows of answers in text form. The image at the top of the question is defaulted at the start,
 * and updated to the value of the last choice the user selects.
 */

var ImageChangingQuestion = function ImageChangingQuestion(_ref) {
  var answers = _ref.answers,
      choices = _ref.choices,
      defaultImage = _ref.defaultImage,
      id = _ref.id,
      subtitle = _ref.subtitle,
      title = _ref.title;
  var dispatch = (0, _reactRedux.useDispatch)();

  var handleAnswerSelect = function handleAnswerSelect(choiceValue) {
    // TODO: add analtyics
    dispatch((0, _wizardsSlice.setAnswer)({
      answer: choiceValue,
      questionPath: id
    }));
  };

  var handleKeyboardEvent = function handleKeyboardEvent(choiceValue, event) {
    if (event.key === 'Enter') {
      handleAnswerSelect(choiceValue);
    }
  };

  var changingImage = answers.length > 0 ? choices.find(function (choice) {
    return choice.value === answers[answers.length - 1];
  }).image : defaultImage;
  return /*#__PURE__*/_react.default.createElement(StyledQuestion, null, /*#__PURE__*/_react.default.createElement(_sharedStyles.Title, null, title), /*#__PURE__*/_react.default.createElement(_sharedStyles.Subtitle, null, subtitle), /*#__PURE__*/_react.default.createElement(LottieWrapper, null, /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, changingImage)), /*#__PURE__*/_react.default.createElement(ChoicesContainer, null, choices.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(Choice, {
      key: choice.value,
      selected: answers.includes(choice.value),
      onClick: function onClick() {
        return handleAnswerSelect(choice.value);
      },
      onKeyDown: function onKeyDown(event) {
        handleKeyboardEvent(choice.value, event);
      }
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckbox, {
      "aria-label": choice.title,
      checked: answers.includes(choice.value),
      id: choice.value,
      onChange: function onChange(e) {},
      name: choice.value,
      type: "checkbox"
    }), /*#__PURE__*/_react.default.createElement("div", null, choice.title));
  })));
};

ImageChangingQuestion.defaultProps = {
  answers: [],
  subtitle: ''
};
var _default = ImageChangingQuestion;
exports.default = _default;